import React from 'react';
import Navbar from '../../components/common/Navbar/Navbar'; 
import './ClientLayout.css';
import RodapeComponent from '../../components/common/RodapeComponent/RodapeComponent';

const ClientLayout = ({ children }) => {
  return (
    <div className="client-layout">
      {/* Navbar at the top */}
      <Navbar />

      {/* Main content, wrapped by the layout */}
      <main className="content">
        <div className='children'>
          {children}
        </div>
      </main>

      <RodapeComponent />
    </div>
  );
};

export default ClientLayout;